import { useDispatch, useSelector } from 'react-redux';
import {
  selectCompleted,
  selectCurrent,
  selectDraftForm,
  selectEditForChanges,
  selectIsStarted,
  selectMyPendingForm,
  selectPreview,
  selectShowMyHistory,
  selectUsingDraft,
  setEditPreview,
} from '../../giftSlice';
import { Box, Button } from '@mui/material';
import { Edit, Save } from '@mui/icons-material';
import { useSubmitFormMutation } from '../../giftApiSlice';
import toast from 'react-hot-toast';

const CandidatePreviewTools = () => {
  const isStarted = useSelector(selectIsStarted);
  const dispatch = useDispatch();
  const [submitForm] = useSubmitFormMutation();
  const completed = useSelector(selectCompleted);
  const preview = useSelector(selectPreview);
  const draftForm = useSelector(selectDraftForm);
  const usingDraft = useSelector(selectUsingDraft);
  const current = useSelector(selectCurrent);
  const pendingForm = useSelector(selectMyPendingForm);
  const isHistory = useSelector(selectShowMyHistory);
  const handleEdit = () => {
    dispatch(setEditPreview({ value: true }));
  };
  const editForChanges = useSelector(selectEditForChanges);
  const handleSubmit = () => {
    let body = { response: preview };
    if (usingDraft) {
      body.updateForm = true;
      body.newForm = false;
      body.formId = draftForm._id;
    }
    if (editForChanges) {
      body.updateForm = true;
      body.newForm = false;
      body.formId = pendingForm?._id;
      body.status = 'Pending';
    }

    submitForm(body);
  };

  const handleSaveAsDraft = async () => {
    let body = { response: preview, isDraft: true, current };
    if (usingDraft) {
      body.updateForm = true;
      body.newForm = false;
      body.formId = draftForm._id;
    }
    submitForm(body);
    toast.success('Draft saved successfully');
  };

  return (
    (isStarted || editForChanges) && (
      <Box sx={{ flex: 0.1, display: isHistory ? 'none' : 'flex', mt: 1, alignItems: 'flex-end', zIndex: 1200 }}>
        {!editForChanges && (
          <Button variant='outlined' size='small' color='success' endIcon={<Save />} onClick={handleSaveAsDraft}>
            Save draft
          </Button>
        )}
        <Button variant='outlined' size='small' sx={{ ml: 1 }} endIcon={<Edit />} onClick={handleEdit}>
          Edit
        </Button>
        <Button variant='contained' size='small' sx={{ ml: 'auto' }} onClick={handleSubmit}>
          Submit
        </Button>
      </Box>
    )
  );
};

export default CandidatePreviewTools;
